/* Marcel Afters, PHASE 3b (11 Oct 2026): Complete the look / Shop the look buttons.
   Size pills, Add to bag per piece, one Add the look for the whole outfit. Adds go through /cart/add.js and the theme's own
   CartLinesUpdateEvent, so the bag drawer opens and refreshes exactly as it does for the main Add to bag.
   Event delegation on document: the bag drawer is re-rendered by the Section Rendering API and still works. No dependencies. */
(function () {
  if (window.__maLook) return; window.__maLook = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function dl(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }

  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', v = cents / 100, whole = cents % 100 === 0;
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(v); }
    catch (e) { return '$' + (whole ? v.toFixed(0) : v.toFixed(2)); }
  }

  /* lines: [{ id, quantity }] */
  async function addLines(source, lines) {
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }), promise: def.promise }));
      } catch (e) { def = null; }
    }
    var body = { items: lines.map(function (l) { return { id: Number(l.id), quantity: l.quantity }; }) };
    var secs = [].map.call(document.querySelectorAll('cart-items-component'), function (n) { return n.dataset && n.dataset.sectionId; }).filter(Boolean);
    if (secs.length) body.sections = secs.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { cart = await (await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'ma-look', sourceId: 'ma-look', itemCount: lines.length, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    }
    return { ok: ok, json: json, events: !!def };
  }
  window.MaXsell = { addLines: addLines, fmt: fmt };

  function box(el) { return el.closest('[data-mxl]'); }
  function msgOf(el) { var b = box(el); return b && b.querySelector('[data-mxl-msg]'); }
  function say(el, t) { var m = msgOf(el); if (m) m.textContent = t || ''; }
  function setLab(btn, t) { var l = btn.querySelector('[data-mxl-lab]'); if (l) l.textContent = t; }
  function flash(el, cls, ms) { el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms || 1300); }
  function scrollTo(el) { try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) {} }

  function chosenId(item) {
    if (item.dataset.single) return item.dataset.single;
    var p = item.querySelector('.mxl__z[aria-pressed="true"]');
    return p ? p.dataset.id : '';
  }
  function updateTotal(b) {
    var t = b && b.querySelector('[data-mxl-tot]'); if (!t) return;
    var sum = +b.dataset.mainPrice || 0;
    [].forEach.call(b.querySelectorAll('[data-mxl-item]'), function (it) { sum += +it.dataset.price || 0; });
    t.textContent = fmt(sum);
  }
  function pick(z) {
    var item = z.closest('[data-mxl-item]');
    [].forEach.call(item.querySelectorAll('.mxl__z'), function (x) { x.setAttribute('aria-pressed', x === z ? 'true' : 'false'); });
    item.dataset.price = z.dataset.price || item.dataset.price;
    var add = item.querySelector('[data-mxl-add]'); setLab(add, 'Add to bag');
    item.classList.remove('is-prompt'); say(item, '');
    updateTotal(box(item));
  }
  function done(btn, label, idle) {
    btn.classList.add('is-added'); setLab(btn, label);
    setTimeout(function () { btn.classList.remove('is-added'); setLab(btn, idle); }, 2200);
  }

  async function addOne(btn) {
    var item = btn.closest('[data-mxl-item]'), id = chosenId(item);
    if (!id) { flash(item, 'is-prompt'); say(item, 'Choose a size for ' + (item.dataset.title || 'this piece') + '.'); var f = item.querySelector('.mxl__z:not([disabled])'); if (f) f.focus({ preventScroll: true }); return; }
    btn.setAttribute('aria-busy', 'true'); say(item, '');
    var r = await addLines(btn, [{ id: id, quantity: 1 }]);
    btn.removeAttribute('aria-busy');
    if (r.ok) {
      dl({ event: 'add_to_cart', source: 'complete_the_look', items: [{ item_id: String(id), quantity: 1 }] });
      done(btn, 'Added', item.querySelector('.mxl__z') ? 'Add to bag' : 'Add to bag');
      if (!r.events) location.href = routes.cart_url || (ROOT + 'cart');
    } else say(item, (r.json && (r.json.description || r.json.message)) || 'Could not add that. Try again.');
  }

  function mainPick() {
    var form = document.querySelector('[data-mx-form]'), idIn = document.querySelector('[data-mx-id]');
    if (!form || !idIn) return { err: 'This page has no size to add.' };
    var fs = document.querySelector('[data-mx-size]');
    if (fs) {
      var parts = [].slice.call(fs.querySelectorAll('[data-mx-part]'));
      var okSize = parts.length ? parts.every(function (p) { return p.querySelector('input:checked'); }) : !!fs.querySelector('input:checked');
      if (!okSize) return { need: fs };
    }
    var add = document.querySelector('[data-mx-add]');
    if (add && add.disabled) return { err: 'That size is sold out. Choose another size above.' };
    var q = document.querySelector('[data-mx-qty-n]'), qty = Math.max(1, Math.min(10, parseInt(q && q.textContent, 10) || 1));
    return { id: idIn.value, qty: qty };
  }

  async function addAll(btn) {
    var b = box(btn), items = [].slice.call(b.querySelectorAll('[data-mxl-item]'));
    var inBag = b.classList.contains('mxl--drawer');   /* the bag has no main product: the look is just the missing pieces */
    var m = inBag ? { id: '', qty: 0 } : mainPick();
    if (m.err) { say(btn, m.err); return; }
    if (m.need) {
      say(btn, 'Choose your size above first, then add the look.');
      var fs = m.need; fs.classList.add('is-prompt'); setTimeout(function () { fs.classList.remove('is-prompt'); }, 1600);
      scrollTo(fs); var fi = fs.querySelector('input'); if (fi) try { fi.focus({ preventScroll: true }); } catch (e) {}
      return;
    }
    var missing = items.filter(function (it) { return !chosenId(it); });
    if (missing.length) {
      missing.forEach(function (it) { flash(it, 'is-prompt'); });
      say(btn, 'Choose a size for ' + missing.map(function (it) { return it.dataset.title; }).join(' and ') + '.');
      scrollTo(missing[0]); var f = missing[0].querySelector('.mxl__z:not([disabled])'); if (f) f.focus({ preventScroll: true });
      return;
    }
    var lines = (inBag ? [] : [{ id: m.id, quantity: m.qty }]).concat(items.map(function (it) { return { id: chosenId(it), quantity: 1 }; }));
    btn.setAttribute('aria-busy', 'true'); say(btn, '');
    var r = await addLines(btn, lines);
    btn.removeAttribute('aria-busy');
    if (r.ok) {
      dl({ event: 'add_to_cart', source: 'add_the_look', items: lines.map(function (l) { return { item_id: String(l.id), quantity: l.quantity }; }) });
      done(btn, 'Added', 'Add the look');
      items.forEach(function (it) { var a = it.querySelector('[data-mxl-add]'); if (a) done(a, 'Added', 'Add to bag'); });
      if (!r.events) location.href = routes.cart_url || (ROOT + 'cart');
    } else say(btn, (r.json && (r.json.description || r.json.message)) || 'Could not add the look. Try again.');
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var z = t.closest('.mxl__z'); if (z && !z.disabled) { pick(z); return; }
    var all = t.closest('[data-mxl-all]'); if (all) { e.preventDefault(); addAll(all); return; }
    var a = t.closest('[data-mxl-add]'); if (a) { e.preventDefault(); addOne(a); }
  });

  /* Desktop buy column is sticky. When it is taller than the window (the look adds rows), let it scroll up until its foot is visible
     and then stick, instead of hiding the foot until the gallery ends. */
  function stick() {
    [].forEach.call(document.querySelectorAll('.mx-pdp__sticky'), function (el) {
      el.style.top = '';
      if (!matchMedia('(min-width: 990px)').matches) return;
      var base = parseFloat(getComputedStyle(el).top) || 100, h = el.offsetHeight;
      if (h + base > innerHeight - 8) el.style.top = Math.min(base, innerHeight - h - 8) + 'px';
      if (!el.__mxlRo && window.ResizeObserver) { el.__mxlRo = new ResizeObserver(function () { clearTimeout(el.__mxlT); el.__mxlT = setTimeout(stick, 80); }); el.__mxlRo.observe(el); }
    });
  }
  addEventListener('resize', function () { clearTimeout(stick.t); stick.t = setTimeout(stick, 120); });
  if (document.readyState === 'complete') stick(); else addEventListener('load', stick);
  function sync() { [].forEach.call(document.querySelectorAll('.mxl--pdp, .mxl--drawer'), updateTotal); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
